import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

import { RichTextComponent } from "@/libraries/design/utils";

import { RoadmapFeature } from "../types.ts";

export interface FeatureDescriptionProps {
    content: RoadmapFeature["description"];
}

export const FeatureDescription = (props: FeatureDescriptionProps) => {
    const html = documentToHtmlString(props.content.json);

    return <RichTextComponent text={html} />;
};
